const dedupeById = (items) => {
    if (!items?.length) {
        return [];
    }
    const seen = new Set();
    return items.filter((item) => {
        if (item?.id == null || seen.has(item.id)) {
            return false;
        }
        seen.add(item.id);
        return true;
    });
};

export const normalizeModelDetail = (data) => {
    if (!data) {
        return data;
    }
    return {
        ...data,
        holes: dedupeById(data.holes),
        roundNotches: dedupeById(data.roundNotches),
    };
};
